import { useState } from 'react';
import { createOrder } from '@/api/orders';
import { createRazorpayOrder, verifyRazorpayPayment } from '@/api/payments';
import { 
  handleApiError, 
  showLoading, 
  dismissToast, 
  handleOrderSuccess, 
  handleOrderError,
  handlePaymentSuccess,
  handlePaymentError
} from '@/utils/toast';

export const useOrders = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const createNewOrder = async (orderData) => {
    const loadingToast = showLoading('Creating your order...');
    
    try {
      setLoading(true);
      setError(null);
      const order = await createOrder(orderData);
      dismissToast(loadingToast);
      handleOrderSuccess();
      return order;
    } catch (err) {
      setError(err);
      dismissToast(loadingToast);
      handleOrderError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const initiateRazorpayPayment = async (orderId) => {
    const loadingToast = showLoading('Initializing payment...');
    
    try {
      setLoading(true);
      setError(null);
      const paymentData = await createRazorpayOrder(orderId);
      dismissToast(loadingToast);
      return paymentData;
    } catch (err) {
      setError(err);
      dismissToast(loadingToast);
      handlePaymentError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const verifyPayment = async (paymentData) => {
    const loadingToast = showLoading('Verifying payment...');
    
    try {
      setLoading(true);
      setError(null);
      const result = await verifyRazorpayPayment(paymentData);
      dismissToast(loadingToast);
      
      if (result.success) {
        handlePaymentSuccess();
      } else {
        handlePaymentError({ message: 'Payment verification failed' });
      }
      
      return result;
    } catch (err) {
      setError(err);
      dismissToast(loadingToast);
      handlePaymentError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    createNewOrder,
    initiateRazorpayPayment,
    verifyPayment
  };
};
